var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6 7.19995C0.931371 7.19995 1.2 7.46858 1.2 7.79995V10.2C1.2 10.3591 1.26321 10.5117 1.37574 10.6242C1.48826 10.7367 1.64087 10.8 1.8 10.8H10.2C10.3591 10.8 10.5117 10.7367 10.6243 10.6242C10.7368 10.5117 10.8 10.3591 10.8 10.2V7.79995C10.8 7.46858 11.0686 7.19995 11.4 7.19995C11.7314 7.19995 12 7.46858 12 7.79995V10.2C12 10.6773 11.8104 11.1352 11.4728 11.4727C11.1352 11.8103 10.6774 12 10.2 12H1.8C1.32261 12 0.864773 11.8103 0.527208 11.4727C0.189642 11.1352 0 10.6773 0 10.2V7.79995C0 7.46858 0.268629 7.19995 0.6 7.19995Z",
    fill: "#4734AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57573 4.37569C2.81004 4.14137 3.18994 4.14137 3.42426 4.37569L5.99999 6.95142L8.57573 4.37569C8.81004 4.14137 9.18994 4.14137 9.42426 4.37569C9.65857 4.61 9.65857 4.9899 9.42426 5.22422L6.42426 8.22422C6.18994 8.45853 5.81004 8.45853 5.57573 8.22422L2.57573 5.22422C2.34142 4.9899 2.34142 4.61 2.57573 4.37569Z",
    fill: "#4734AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 0C6.33136 0 6.59999 0.268629 6.59999 0.6V7.8C6.59999 8.13137 6.33136 8.4 5.99999 8.4C5.66862 8.4 5.39999 8.13137 5.39999 7.8V0.6C5.39999 0.268629 5.66862 0 5.99999 0Z",
    fill: "#4734AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b7cec8b0ee5332607a6559fbfeb24f56.svg";
export { ForwardRef as ReactComponent };